import { jsonldAddressLocality } from './JsonldStore';

export const updateJsonldAddressLocality = (value) => jsonldAddressLocality.update((oldValue) => value);
